import API from '../services/api-config.service';

export function login(payload) {
  
  return API({
    method: 'POST',
    url: `/authenticate`,
    data: JSON.stringify(payload)
  });
}

export function forgotPassword(payload) {
  
  return API({
    method: 'POST',
    url: `/forgotPassword`,
    data: JSON.stringify(payload)
  });
}

export function resetPassword(payload) {
  
  return API({
    method: 'PUT',
    url: `/resetPassword`,
    data: JSON.stringify(payload)
  });
}

export function studentRegistration(payload) {
  
  return API({
    method: 'POST',
    url: `/studentRegistration`,
    data: JSON.stringify(payload)
  });
}

export function changePassword(payload) {
  return API({
    method: 'POST',
    url: `/changePassword`,
    data: JSON.stringify(payload)
  });
}
